import React, { useState, useEffect } from 'react';
import { useTitle } from '../../../context/TitleContext';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowLeft, FaSave, FaHeadset } from 'react-icons/fa';
import { showSuccessToast, showErrorToast } from '../../../shared/utils/toastHelper';
import apiClient from '../../../shared/utils/apiConfig';

const AdminSupportAdd = () => {
    const { setTitle } = useTitle();
    const navigate = useNavigate();
    
    const [formData, setFormData] = useState({
        question_ar: '',
        question_en: '',
        answer_ar: '',
        answer_en: ''
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setTitle('إضافة سؤال دعم جديد');
    }, [setTitle]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!formData.question_ar.trim() || !formData.question_en.trim()) {
            showErrorToast('يرجى ملء السؤال بالعربية والإنجليزية');
            return;
        }

        if (!formData.answer_ar.trim() || !formData.answer_en.trim()) {
            showErrorToast('يرجى ملء الإجابة بالعربية والإنجليزية');
            return;
        }

        try {
            setLoading(true);
            
            await apiClient.post('/admin/support-questions', formData);
            
            showSuccessToast('تم إضافة السؤال بنجاح');
            navigate('/admin-support');
        } catch (error) {
            showErrorToast(error.response?.data?.message || 'فشل في إضافة السؤال');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="main_content">
            <div className="dashboard-container">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex align-items-center">
                        <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            className="btn btn-outline-secondary mx-3"
                            onClick={() => navigate('/admin-support')}>
                            <FaArrowLeft className="mx-2" />
                            العودة
                        </motion.button>
                        <h4 className="mb-0">إضافة سؤال دعم جديد</h4>
                    </div>
                </div>

                {/* Form */}
                <div className="card shadow-lg border-0">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6 mb-4">
                                    <label className="form-label">
                                        <FaHeadset className="mx-2" />
                                        السؤال (عربي) *
                                    </label>
                                    <textarea
                                        className="form-control"
                                        name="question_ar"
                                        value={formData.question_ar}
                                        onChange={handleInputChange}
                                        rows="4"
                                        placeholder="أدخل السؤال باللغة العربية..."
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-4">
                                    <label className="form-label">
                                        <FaHeadset className="mx-2" />
                                        السؤال (إنجليزي) *
                                    </label>
                                    <textarea
                                        className="form-control"
                                        name="question_en"
                                        value={formData.question_en}
                                        onChange={handleInputChange}
                                        rows="4"
                                        placeholder="Enter the question in English..."
                                        required
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 mb-4">
                                    <label className="form-label">
                                        <FaHeadset className="mx-2" />
                                        الإجابة (عربي) *
                                    </label>
                                    <textarea
                                        className="form-control"
                                        name="answer_ar"
                                        value={formData.answer_ar}
                                        onChange={handleInputChange}
                                        rows="6"
                                        placeholder="أدخل الإجابة باللغة العربية..."
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-4">
                                    <label className="form-label">
                                        <FaHeadset className="mx-2" />
                                        الإجابة (إنجليزي) *
                                    </label>
                                    <textarea
                                        className="form-control"
                                        name="answer_en"
                                        value={formData.answer_en}
                                        onChange={handleInputChange}
                                        rows="6"
                                        placeholder="Enter the answer in English..."
                                        required
                                    />
                                </div>
                            </div>

                            <div className="d-flex justify-content-end gap-3">
                                <motion.button
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={() => navigate('/admin-support')}>
                                    إلغاء
                                </motion.button>
                                <motion.button
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={loading}>
                                    {loading ? (
                                        <>
                                            <div className="spinner-border spinner-border-sm mx-2" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            جاري الحفظ...
                                        </>
                                    ) : (
                                        <>
                                            <FaSave className="mx-2" />
                                            حفظ السؤال
                                        </>
                                    )}
                                </motion.button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminSupportAdd;
